import { useState, useEffect } from "react";
import { FaDownload } from "react-icons/fa";
import "./CSS/Subscription.css";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Modal } from "react-bootstrap";
import PaymentInvoice from "./PaymentInvoice";
import closeimg from "../Assets/closeimg.svg";
import UserIconOrenge from "../Assets/UserIconOrenge.svg";
import electricIcon from "../Assets/electricIcon.svg";
import { X } from "lucide-react";
import plan1 from "../Assets/plan1.png";
import plan2 from "../Assets/plan2.png";
import plan3 from "../Assets/plan3.png";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import goodmarkImg from "../Assets/goodmarkImg.svg";

import {
  removeData,
  retrieveData,
  storeData,
} from "../LocalConnection/LocalConnection";

import {
  server_post_data,
  custom_package_All,
  cancel_subs,
  firebase_notification,
  pre_pay_payment,
} from "../ServiceConnection/serviceconnection";
import {
  empty_form,
  handleError,
  handleSuccess,
} from "../CommonJquery/CommonJquery";
import Loader from "../pages/Loader";
import { toast } from "react-toastify";
const payments = [
  { name: "John Doe", date: "2024-12-10", plan: "Premium", invoiceId: "12345" },
  { name: "Jane Smith", date: "2024-12-09", plan: "Basic", invoiceId: "12346" },
];

export default function Subscription() {
  let final_bus_id = retrieveData("final_bus_id");

  const [showModal, setShowmodal] = useState(false);
  const [showModal2, setShowmodal2] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState([]);
  const navigate = useNavigate();

  const [dowloadPdf, setdowloadPdf] = useState(false);
  const [invoiceId, setInvoiceId] = useState(null);

  const [ShowLoaderAdmin, setShowLoaderAdmin] = useState(false);
  const [customerInvoice, setCustomerInvoice] = useState([]);
  const [customerdata, setCustomerdata] = useState([]);
  const [customerdataname, setCustomerdataName] = useState([]);
  const [showModal3, setShowModal] = useState(false);
  const [activeTab, setActiveTab] = useState("monthly");
  const [selectedCountry, setSelectedCountry] = useState("india");
  const [DateCount, setDateCount] = useState(0);
  const [pricingPlansnew, setpricingPlansnew] = useState([]);
  const [IsLoading, setIsLoading] = useState(false);

  const [isClearing, setIsClearing] = useState(false);
  const planImages = {
    "plan1.svg": plan1,
    "plan2.svg": plan2,
    "plan3.svg": plan3,
  };

  const [selectedOption, setSelectedOption] = useState(
    "Select Business Option",
  );

  const create = "Create";

  const handleshowModal = (index) => {
    setShowmodal(!showModal);
    setSelectedPayment(customerInvoice[index]);
  };
  const handleDownloadPdf = (index) => {
    setdowloadPdf(true);
    setSelectedPayment(customerInvoice[index]);
  };

  const handleModalClose = () => {
    setShowmodal2(false);
  };
  const closeModal = () => {
    setShowModal(false);
  };

  const detectUserCountry = async () => {
    try {
      const response = await fetch("https://ipapi.co/json/");
      const data = await response.json();
      const country = data.country_code === "IN" ? "india" : "usa";
      setSelectedCountry(country);
    } catch (error) {
      console.log(error);
    }
  };

  const handleCancelSub = async () => {
    setShowLoaderAdmin(true);
    await server_post_data(cancel_subs, null)
      .then((Response) => {
        let data = Response.message.split("~@~");
        const final_data = JSON.parse(data[1]);
        if (parseInt(data[0]) === 1) {
          handleError(final_data.message);
        } else {
          console.log("Subscription Cancelled");
          handleModalClose();
          handleSuccess(
            "Your Subscription has been succesfully cancelled, you will not be charged from the next cycle",
          );
        }
        setShowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setShowLoaderAdmin(false);
      });
  };

  const handleModalOpen = () => {
    setShowmodal2(true);
  };

  const handlepayment = async (plan) => {
    const hasErrors = false;
    if (!hasErrors) {
      setIsLoading(true);
      let fd_from = new FormData();
      fd_from.append("id_add", plan.id_add);
      fd_from.append("flag", "1");
      await server_post_data(pre_pay_payment, fd_from)
        .then((Response) => {
          setIsLoading(false);
          let data1 = Response.message.split("~@~");
          if (parseInt(data1[0]) === 1) {
            handleError(data1[1]);
          } else {
            const chargebeeCheckoutUrl = data1[1];
            // Redirect to Chargebee checkout page
            window.location.href = chargebeeCheckoutUrl;
          }
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }
  };

  const handleNavigate = () => {
    navigate("https://www.wowreviews.co/contact", { target: "_blank" });
  };

  const master_data_get1 = async (flag) => {
    var formdata = new FormData();
    formdata.append("clear_or_not", flag);
    await server_post_data(firebase_notification, formdata)
      .then((Response) => {
        let data = Response.message.split("~@~");
        const final_data = JSON.parse(data[1]);
        if (parseInt(data[0]) === 1) {
          handleError(final_data.message);
        } else {
          // console.log("Pricing Plans", final_data.price_data);
          const selectedPlanAmount = parseFloat(
            retrieveData("price_amount_package"),
          );
          const formattedSelectedPlan =
            selectedPlanAmount % 1 === 0
              ? selectedPlanAmount.toFixed(0)
              : selectedPlanAmount.toFixed(2);
          console.log("Pricing Raw", final_data.price_data);
          const updatedPlans = final_data.price_data.map((plan) => {
            if (!plan.pricing) return plan;

            const pricingInfo = plan.pricing[selectedCountry]?.[activeTab];
            if (!pricingInfo) return plan;

            const strippedPrice = pricingInfo.price.replace(/[^0-9.]/g, "");
            const isSelected = strippedPrice === formattedSelectedPlan;

            const selectedplanTrail =
              final_data.total_business_list?.find(
                (item) => item.bus_id === final_bus_id,
              )?.trail_or_no || null;

            return {
              ...plan,
              price: pricingInfo.price,
              id_add: pricingInfo.id_add,
              buttonText:
                selectedplanTrail === "1"
                  ? isSelected
                    ? "Buy Now"
                    : "Upgrade Now"
                  : isSelected
                    ? "Current Plan"
                    : "Upgrade Now",
              isSelected, // ✅ Custom flag added
            };
          });
          setpricingPlansnew(updatedPlans);
          // console.log("hello", final_data.user_data)
          setSelectedOption(
            final_data.total_business_list?.find(
              (item) => item.bus_id === final_bus_id,
            )?.business_name || null,
          );
        }
        if (flag == 1) {
          setIsClearing(false);
        }
      })
      .catch((error) => {
        handleError("network");
      });
  };

  console.log("Pricing", pricingPlansnew);

  const master_data_get = async () => {
    setShowLoaderAdmin(true);
    await server_post_data(custom_package_All, null)
      .then((Response) => {
        let data = Response.message.split("~@~");
        const final_data = JSON.parse(data[1]);
        if (parseInt(data[0]) === 1) {
          handleError(final_data.message);
        } else {
          console.log(final_data);
          setCustomerdata(final_data.User_Data);
          setCustomerdataName(final_data.User_Data[0]);
          setCustomerInvoice(final_data.Invoice_Data);
        }
        setShowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setShowLoaderAdmin(false);
      });
  };
  useEffect(() => {
    master_data_get();
    detectUserCountry();
    master_data_get1();
  }, []);
  const handleCloseModal = () => {
    setShowmodal(false);
  };
  return (
    <>
      {ShowLoaderAdmin && <Loader />}
      <div>
        <div className="SubscriptionHead">
          <h3>Billing and Invoices</h3>
        </div>

        <div className="PlanDivCont">
          <div className="MyPlan">
            {" "}
            <h2>My Plan</h2>
            <span>:</span>
            <p>
              {customerInvoice &&
                customerInvoice.length > 0 &&
                customerInvoice[0].package_name}
            </p>
          </div>
          <div className="MyPlan2">
            <h2>Start Date</h2>
            <span>:</span>
            <p>
              {" "}
              {customerInvoice &&
                customerInvoice.length > 0 &&
                new Date(customerInvoice[0].entry_date).toLocaleDateString(
                  "en-GB",
                )}
            </p>
          </div>
          <div className="MyPlan2">
            <h2>End Date</h2>
            <span>:</span>

            <p>
              {" "}
              {customerInvoice &&
                customerInvoice.length > 0 &&
                new Date(customerInvoice[0].end_date).toLocaleDateString(
                  "en-GB",
                )}
            </p>
          </div>
          <div className="buttonContainer">
            <div className="canclAndUpgradeSub">
              <button
                type="button"
                className="CencelBttn"
                onClick={handleModalOpen}
              >
                Cancel Subscription
              </button>
              {/* <Link to="/Pricing">
            <button type="button">Upgrade Plan</button>
          </Link> */}
            </div>
            <div className="canclAndUpgradeSub">
              <button
                type="button"
                className="CencelBttn"
                onClick={setShowModal}
              >
                Upgarade Plan
              </button>
              {/* <Link to="/Pricing">
            <button type="button">Upgrade Plan</button>
          </Link> */}
            </div>
          </div>
        </div>

        <div className="PaymntsData">
          <h1>Payments</h1>

          <div className="tableData">
            <table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Date</th>
                  <th>Plan</th>
                  <th>Invoice ID</th>
                  <th>Download</th>
                </tr>
              </thead>
              <tbody>
                {customerInvoice.map((payment, index) => (
                  <tr key={index}>
                    <td>{customerdataname.full_name}</td>
                    <td>
                      {new Date(payment.start_date).toLocaleDateString("en-GB")}
                    </td>
                    <td>{payment.package_name}</td>
                    <td className="invoiceId">
                      {payment.transaction_id &&
                      payment.transaction_id != "" &&
                      payment.transaction_id.length > 5
                        ? payment.transaction_id.slice(0, 5) + "..."
                        : payment.transaction_id}
                    </td>

                    <td>
                      <div className="d-flex gap-3 downloadIcon">
                        <Icon
                          onClick={() => handleshowModal(index)}
                          icon="iconamoon:eye-light"
                        />
                        <FaDownload
                          onClick={() => {
                            handleDownloadPdf(index);
                          }}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        {/**-------------Status Modal--------------- */}
        <Modal
          size="lg"
          className="paymentInvoiceModal"
          centered
          show={showModal}
          onHide={!showModal}
          backdrop={"static"}
        >
          <Modal.Body>
            <div className="closeInvoiceSubs" onClick={handleCloseModal}>
              <img src={closeimg} alt="close"></img>
            </div>
            <PaymentInvoice
              customerdataname={customerdataname}
              customerInvoice={selectedPayment}
            />
          </Modal.Body>
        </Modal>

        <Modal
          size="md"
          className="statusModal"
          centered
          show={showModal2}
          onHide={handleModalClose}
          backdrop={"static"}
        >
          <Modal.Body>
            <div className="statusContntDiv">
              <div className="d-flex flex-column align-items-center">
                <img src={UserIconOrenge} alt="UserIconOrenge"></img>
                <p>
                  Are you sure you want to cancel your Wowreviews subscription.
                </p>
              </div>
            </div>
          </Modal.Body>
          <div className="d-flex justify-content-center bttmnsStus">
            {" "}
            <button
              className="AddEventbutton CencelllBttn"
              onClick={handleModalClose}
              type="button"
            >
              Go Back
            </button>
            <button
              className="AddEventbutton Yesbttn"
              type="button"
              onClick={handleCancelSub}
            >
              Cancel Subscription
            </button>
          </div>
        </Modal>

        <Modal
          show={showModal3}
          onHide={closeModal}
          centered
          backdrop="static"
          dialogClassName="modal-2xl"
          scrollable
          className="modal_pricing_div"
        >
          <Modal.Header closeModal>
            <Modal.Title>
              <X
                size={25}
                onClick={() => closeModal()}
                className="close_model_div_pricing"
              />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ position: "relative" }}>
            <div className="PricingDiv">
              <div className="pricingTOpHead">
                <div className="d-flex gap-1 align-items-center">
                  <img src={electricIcon} alt="electricIcon" />
                  <p>Pricing Plans</p>
                </div>

                <h1>Simple Plan for Build Business Like Yours</h1>

                {/* Tabs for switching between Monthly and Yearly */}
                <div className="tabs">
                  <button
                    className={`tabButton ${
                      activeTab === "monthly" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("monthly")}
                  >
                    Monthly
                  </button>
                  <button
                    className={`tabButton ${
                      activeTab === "yearly" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("yearly")}
                  >
                    Annual <span className="freeText">(2 Month Free)</span>
                  </button>
                </div>
              </div>

              <div className="row margnClass">
                {pricingPlansnew.map((plan, index) => (
                  <div className="col-lg-4 col-md-6 col-sm-6 mt-3" key={index}>
                    <div
                      className={`DataprinceBox1 ${
                        plan.isSelected ? "selected" : ""
                      }`}
                    >
                      <img
                        src={planImages[plan.imgSrc] || "/placeholder.svg"}
                        alt={`Plan ${index + 1}`}
                      />
                      <h3>{plan.title}</h3>
                      <p>{plan.description}</p>
                      {plan.price && (
                        <h1>
                          {plan.price}
                          <span style={{ fontSize: "14px", color: "gray" }}>
                            /month{" "}
                            {selectedCountry === "india"
                              ? "(Including GST)"
                              : "(Excl. Tax)"}
                          </span>
                        </h1>
                      )}
                      {activeTab === "yearly" && index !== 2 && (
                        <p className="billedText">Billed Annually</p>
                      )}

                      <div className="amount">
                        <button
                          className={
                            plan.id_add === "0@@@0" ? "margin_55_top" : ""
                          }
                          disabled={plan.buttonText === "Current Plan"}
                          onClick={() =>
                            plan.id_add !== "0@@@0"
                              ? handlepayment(plan)
                              : handleNavigate()
                          }
                        >
                          {plan.buttonText}
                        </button>
                      </div>
                      <ul>
                        {plan.features.map((feature, featureIndex) => (
                          <div className="d-flex margnLabal" key={featureIndex}>
                            <img
                              src={goodmarkImg || "placeholder.svg"}
                              alt="Goodmark"
                              className="GreenMarkImng"
                            />
                            <label>
                              <strong>{feature.text}</strong>{" "}
                              {feature.additionalText}
                            </label>
                          </div>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <div className="paymentInvoiceHide" style={{ display: "none" }}>
          <PaymentInvoice
            dowloadPdf={dowloadPdf}
            invoiceId={invoiceId}
            customerdataname={customerdataname}
            customerInvoice={selectedPayment}
            handleDownloadPdf={() => setdowloadPdf(false)}
          />
        </div>
      </div>
    </>
  );
}
